export default {
  title: 'Betalingsgegevens geverifieerd',
  description: 'Uw betalingsgegevens zijn succesvol geverifieerd.',
};
